<template>
  <v-card class="mb-6">
    <div class="title-bar d-flex justify-center">
      <div class="title">{{ title }}</div>
    </div>

    <v-card-text>
      <!-- Master checkbox (optional) -->
      <!-- <p>{{ master }}</p> -->

      <v-checkbox
        style="margin-bottom: 1rem;"
        v-if="master && master.model && 'value' in master.model"
        v-model="master.model.enabled"
        color="#0F998E"
        hide-details
        :label="master.label"
      />
      <v-checkbox
        v-else-if="master && master.model && master.field"
        style="margin-bottom: 1rem;"
        v-model="master.model[master.field]"
        color="#0F998E"
        hide-details
        :label="master.label"
      />

      <!-- Items -->
      <!-- <details>
        <summary>jj</summary>
        <p>{{ orderedItems }}</p>
      </details> -->
      <div
        v-for="item in orderedItems"
        :key="item.key"
        :class="indentClass(item)"
      >
        <!-- Top-level special -->
        <v-checkbox
          style="margin-bottom: 1rem;"
          v-if="item.type === 'special'"
          v-model="item.model[item.field]"
          color="#0F998E"
          hide-details
          :label="item.label"
          :disabled="isDisabled(master)"
        />

        <!-- Global setting -->
        <GlobalSettingItem
        v-else
          v-model="item.ref"
          :label="appropriateName(item.key)"
          :disabled="isDisabled(master)"
          :suffix="item.key === 'permission_revert_invoice_timeout' ? 'min' : ''"
        />
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import GlobalSettingItem from "./GlobalSettingItem.vue";

export default {
  name: "SettingsGroup",
  components: { GlobalSettingItem },
  props: {
    title: { type: String, required: true },
    settings: { type: Array, required: true },
    special: { type: Array, default: () => [] },
    master: { type: Object, default: null },
    disabledCondition: { type: Boolean, default: false },
    appropriateName: { type: Function, required: true },
    orderMap: { type: Object, default: () => ({}) }
  },
  computed: {
    orderedItems() {
      const combined = [
        ...this.special.map(s => ({
          ...s,
          type: "special",
          order: this.orderMap[s.key] || 999
        })),
        ...this.settings.map(ref => ({
          key: ref.key,
          ref,
          type: "setting",
          order: this.orderMap[ref.key] || 999
        }))
      ];
      return combined.sort((a, b) => a.order - b.order);
    }
  },
  methods: {
    isDisabled(master) {
      if (this.disabledCondition) return true
      if (!master || !master.model) return false  // guard added

      // handle both shapes safely
      if ('value' in master.model) {
        return !master.model.enabled
      } else if (master.field) {
        return !master.model[master.field]
      }

      return false
    },
    indentClass(setting) {
      if (setting.key === "permission_setting_skip_fiscalization") {
        return "ml-24"; // special deeper nesting
      }
       return this.master ? "ml-12" : "";
    },
  }
};
</script>

<style scoped>
.ml-24 {
  margin-left: 5rem;
}
</style>